import type { User } from "../types/User";

// The green tick on a talent's Instagram means VERIFIED: by Meta (they signed in
// with Instagram, and it's still the handle on the profile) or by us (the founder
// approved the account). Founder, 2026-09-24: "either way they can have a green
// tick mark because they've been verified by either us or Meta." A handle typed
// by an account still waiting for review gets none.
export function instagramVerifiedAs(profile: Pick<User, "instagram" | "instagramVerification">): string {
  const verifiedName = (profile.instagramVerification?.username || "").trim();
  const savedHandle = (profile.instagram || "").trim().replace(/^@+/, "");
  return verifiedName && savedHandle && verifiedName.toLowerCase() === savedHandle.toLowerCase() ? verifiedName : "";
}

export function talentTickEarned(profile: Pick<User, "instagram" | "instagramVerification" | "approvalStatus">): boolean {
  return !!instagramVerifiedAs(profile) || profile.approvalStatus === "approved" || profile.approvalStatus === undefined;
}
